export const routes = {
    landing: "/home",
    login: "/login",
    register: "/register",
    registerForm: "/register/:userType",
    dashboard: "/dashboard",
    forgotPassword: "/forgotPassword"
}